/*
* @Author: gujianghua
* @Date:   2019-10-10 11:38:30
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-10-23 17:43:19
*/
import { service } from '@/utils/request'

export default {
	// 获取学习人数
	getLearnDoc(params) {
	    return service({
	      url: '/cloud/statistic/getStudyCount',
	      method: 'get',
	      params: params
	    })
	},
	// 获取学习时长
	getLearnTime(params) {
	    return service({
	      url: '/cloud/statistic/getTotalStudyTime',
	      method: 'get',
	      params: params
	    })
	},
	getLearnTimeTrend(params) {
	    return service({
	      url: '/cloud/statistic/getChartData',
	      method: 'get',
	      params: params
	    })
	},
  	//获取医生学习列表
  	getList(params) {
	    return service({
	      url: '/cloud/statistic/getDoctorStudyRankList',
	      method: 'get',
	      params: params
	    })
  	},
  	// 获取课程列表
  	getCourseList(params) {
	    return service({
	      url: '/cloud/statistic/getCourseStudyRankList',
	      method: 'get',
	      params: params
	    })
  	},
  	//获取医生学习课程
  	getCourseById(params) {
	    return service({
	      url: '/cloud/statistic/getCourseById',
	      method: 'get',
	      params: params
	    })
  	},
  	// 获取课程学习医生
  	getDoctorById(params) {
	    return service({
	      url: '/cloud/statistic/getDoctorById',
	      method: 'get',
	      params: params
	    })
  	},
  	// 医生列表
  	docList(params) {
	    return service({
	      url: '/cloud/uac/v1/users/doctors/search',
	      method: 'get',
	      params: params
	    })
  	},
  	// 认证用户
  	authDoc(params) {
	    return service({
	      url: '/cloud/statistic/getDoctorByHospital',
	      method: 'get',
	      params: params
	    })
  	},
  	// 医院包用户
  	joinDoc(params) {
	    return service({
	      url: '/cloud/statistic/getDoctorByHospitalAndTime',
	      method: 'get',
	      params: params
	    })
  	},
}


// WEBPACK FOOTER //
// ./src/api/thirdManage/hospitalFolder.js